<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "PRODUCT_UPSELL_PANEL.TITLE" | translate }}
      <span *ngIf="productName" class="panel-subtitle">
        {{ productName
        }}<ng-container *ngIf="shopName"> — {{ shopName }}</ng-container>
      </span>
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <div
      *ngIf="isLoading"
      class="flex-column-center-center"
      style="padding: 32px"
    >
      <mat-spinner [diameter]="32"></mat-spinner>
    </div>

    <div *ngIf="!isLoading" class="flex-column">
      <!-- Avertissement groupe partagé (hérité) -->
      <div *ngIf="sharedCount > 0" class="shared-warning flex-row-start-center">
        <mat-icon class="mr-8">group</mat-icon>
        <span>
          {{
            "PRODUCT_UPSELL_PANEL.SHARED_WARNING"
              | translate: { count: sharedCount }
          }}
        </span>
      </div>

      <div class="mat-caption" style="margin-bottom: 12px">
        {{ "PRODUCT_UPSELL_PANEL.HINT" | translate }}
      </div>

      <mat-form-field floatLabel="auto" class="mr-4 fxFlexAuto">
        <mat-label>{{ "PRODUCT_UPSELL_PANEL.SEARCH" | translate }}</mat-label>
        <input
          id="search"
          [(ngModel)]="filterValue"
          (ngModelChange)="onSearchChange()"
          matInput
        />
        <button
          mat-button
          *ngIf="filterValue"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <div class="flex-row" style="margin-bottom: 16px">
        <div class="flex-column fxFlex-100p">
          <div class="pb-4 mat-caption flex-row-center-start">
            {{ "PRODUCT_UPSELL_PANEL.LEFT_LIST_LABEL" | translate }}
          </div>
        </div>
        <div class="flex-column fxFlex-100p">
          <div class="pb-4 mat-caption flex-row-center-start">
            {{ "PRODUCT_UPSELL_PANEL.RIGHT_LIST_LABEL" | translate }}
          </div>
        </div>
      </div>

      <div cdkDropListGroup class="flex-row">
        <!-- Produits du catalogue (recherche) -->
        <div
          cdkDropList
          [cdkDropListData]="availableResults"
          class="ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list fxFlex-50p"
        >
          <div
            *ngIf="isSearching"
            class="flex-column-center-center fxFlex-100p"
          >
            <mat-spinner [diameter]="28"></mat-spinner>
          </div>

          <div
            *ngIf="!isSearching && !canSearch"
            class="flex-column-center-center fxFlex-100p combo-list-empty-message"
          >
            {{ "PRODUCT_UPSELL_PANEL.TYPE_TO_SEARCH" | translate }}
          </div>

          <div
            *ngIf="!isSearching && canSearch && availableResults.length === 0"
            class="flex-column-center-center fxFlex-100p combo-list-empty-message"
          >
            {{ "PRODUCT_UPSELL_PANEL.NO_RESULTS" | translate }}
          </div>

          @for (product of availableResults; track product.uuid) {
            <div
              *ngIf="!isSearching"
              cdkDragHandle
              matRipple
              [cdkDragData]="product"
              cdkDrag
              [cdkDragDisabled]="mobileLayout.isMobileLayout()"
            >
              <div class="product-child-item flex-row-space-between-center">
                <div class="flex-row-start-center">
                  <mat-icon *ngIf="!mobileLayout.isMobileLayout()" class="mr-8"
                    >drag_handle</mat-icon
                  >
                  <div class="item-name-internal">
                    {{ product.name_internal || product.name }}
                  </div>
                </div>
                <div class="flex-row-end-center">
                  <mat-icon class="ml-8 mr-8" (click)="onAddItem(product)"
                    >add</mat-icon
                  >
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Suggestions de ce produit (ordre = ordre d'affichage CEL) -->
        <div
          cdkDropList
          [cdkDropListData]="suggestions"
          (cdkDropListDropped)="onSuggestionsDrop($event)"
          class="ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list fxFlex-50p"
        >
          <div
            *ngIf="suggestions.length === 0"
            class="flex-column-center-center fxFlex-100p combo-list-empty-message"
          >
            {{ "PRODUCT_UPSELL_PANEL.NO_SUGGESTIONS" | translate }}
          </div>

          @for (item of suggestions; track item.product_uuid; let i = $index) {
            <div
              matRipple
              cdkDragHandle
              [cdkDragData]="item"
              cdkDrag
              [cdkDragDisabled]="mobileLayout.isMobileLayout()"
            >
              <div
                class="product-child-item-right flex-row-space-between-center"
              >
                <div class="flex-row-start-center">
                  <mat-icon *ngIf="!mobileLayout.isMobileLayout()" class="mr-8"
                    >drag_handle</mat-icon
                  >
                  <div class="item-name-internal">
                    {{ item.name }}
                    <span
                      *ngIf="item.amount !== null && item.amount !== undefined"
                      class="suggestion-amount"
                    >
                      {{ formatAmount(item.amount) }}
                    </span>
                  </div>
                </div>
                <div class="flex-row-end-center">
                  <mat-icon class="ml-8 mr-8" (click)="onRemoveItem(i)"
                    >delete</mat-icon
                  >
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Options avancées : titre du panneau client + actif -->
      <div class="advanced-section">
        <button
          mat-button
          type="button"
          class="advanced-toggle"
          (click)="showAdvanced = !showAdvanced"
        >
          <mat-icon>{{
            showAdvanced ? "expand_less" : "expand_more"
          }}</mat-icon>
          {{ "PRODUCT_UPSELL_PANEL.ADVANCED" | translate }}
        </button>

        <div *ngIf="showAdvanced" class="flex-column advanced-fields">
          <div class="mat-caption">
            {{ "PRODUCT_UPSELL_PANEL.TITLE_HINT" | translate }}
          </div>
          <mat-form-field floatLabel="auto">
            <mat-label>{{
              "PRODUCT_UPSELL_PANEL.TITLE_FR" | translate
            }}</mat-label>
            <input
              matInput
              [(ngModel)]="titleFr"
              placeholder="{{
                'PRODUCT_UPSELL_PANEL.TITLE_DEFAULT_FR' | translate
              }}"
            />
          </mat-form-field>
          <mat-form-field floatLabel="auto">
            <mat-label>{{
              "PRODUCT_UPSELL_PANEL.TITLE_EN" | translate
            }}</mat-label>
            <input
              matInput
              [(ngModel)]="titleEn"
              placeholder="{{
                'PRODUCT_UPSELL_PANEL.TITLE_DEFAULT_EN' | translate
              }}"
            />
          </mat-form-field>
          <mat-slide-toggle [(ngModel)]="isActive">
            {{ "PRODUCT_UPSELL_PANEL.IS_ACTIVE" | translate }}
          </mat-slide-toggle>
          <mat-form-field floatLabel="auto" class="checkout-trigger-field">
            <mat-label>{{
              "PRODUCT_UPSELL_PANEL.CHECKOUT_TRIGGER" | translate
            }}</mat-label>
            <mat-select [(ngModel)]="checkoutTrigger">
              <mat-option
                *ngFor="let option of checkoutTriggerOptions"
                [value]="option.value"
              >
                {{ option.label | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="mat-caption">
            {{ "PRODUCT_UPSELL_PANEL.CHECKOUT_TRIGGER_HINT" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="panel-footer flex-row-center-center">
    <button
      mat-raised-button
      (click)="close()"
      class="mr-8"
      [disabled]="isSaving"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
    <ng-container *ngxPermissionsOnly="P.UPSALE_EDIT">
      <button
        mat-raised-button
        (click)="onSave()"
        class="accent"
        [disabled]="isLoading || isSaving"
      >
        <span *ngIf="!isSaving">{{ "GENERIC.SAVE" | translate }}</span>
        <mat-spinner *ngIf="isSaving" [diameter]="20"></mat-spinner>
      </button>
    </ng-container>
  </footer>
</div>
